import { Alert, AlertTitle, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    alert: {
        background: theme.palette.tailwind.sky[50],
        borderRadius: ".5rem",
    },
    alertTitle: {
        color: theme.palette.tailwind.sky[700],
        fontWeight: "normal",
    },
}))

type StandardAlertInfoProps = Readonly<{ title: string; icon?: boolean }>

export function StandardAlertInfo({ title, icon }: StandardAlertInfoProps) {
    const { classes } = useStyles()

    return (
        <Alert severity="info" icon={icon} className={classes.alert}>
            <AlertTitle className={classes.alertTitle}>
                <Typography variant="body2">{title}</Typography>
            </AlertTitle>
        </Alert>
    )
}
